/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Contact Us</h4>

<p>
    Having difficulties? Clicking this will save a file containing debugging information about the current model and state of the system. Please email it to us with any other comments you may have at
    <a href="mailto:support@phi3d.com">support@phi3d.com</a>
</p>`;

export default function BugTooltip() {
    return h('div', { innerHTML: body });
}
